import { render, staticRenderFns } from "./SatisfactionAssessment.vue?vue&type=template&id=24d710d0&scoped=true&"
import script from "./SatisfactionAssessment.vue?vue&type=script&lang=js&"
export * from "./SatisfactionAssessment.vue?vue&type=script&lang=js&"
import style0 from "./SatisfactionAssessment.vue?vue&type=style&index=0&id=24d710d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d710d0",
  null
  
)

export default component.exports